import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Wrapper, StyledTitle, Cube, StyledButton } from './styled'
import { useHistory } from 'react-router-dom'

const ImageTitleButtonBlock = (props) => {
    const history = useHistory()

    const handleRedirect = () => {
        history.push(props.button.url)
    }

    return (
        <Row className='mx-0 px-0'>
            <Col xs={12} className='px-0'>
                <Wrapper image={props.image.url}>
                    <Cube className='d-none d-lg-block'/>
                    <StyledTitle>{props.title}</StyledTitle>
                    <StyledButton onClick={handleRedirect} label={props.button.title} fontSize={'1.3em'} />
                </Wrapper>
            </Col>
        </Row>
    )
}

export default ImageTitleButtonBlock